module.exports = __webpack_public_path__ + "static/media/msawt_awt_icon.fb08219f.ico";